<template>
  <div class="main_box">
    <div class="header_box">
      <div class="logo_box">
        <div class="logo">
          <img src="../../src/assets/images/logo.png" alt="" />
        </div>
        <div class="menu_box">
          <div
            class="menu"
            :class="menuIndex === item.value ? 'menu_act' : ''"
            v-for="(item, index) in menus"
            @click="changeMenu(item, index)"
            :key="index"
          >
            {{ $t(item.name) }}
          </div>
          <!-- 语言切换 -->
          <div class="lang-switch" v-if="currentLang">
            <span
              :class="{ active: currentLang === 'zh' }"
              @click="switchLang('zh')"
              >中</span
            >
            <span>|</span>
            <span
              :class="{ active: currentLang === 'en' }"
              @click="switchLang('en')"
              >EN</span
            >
          </div>
        </div>
      </div>
    </div>
    <div class="content_box">
      <router-view />
    </div>
    <div class="more_box">
      <img
        v-if="$i18n.language !== 'en'"
        src="../assets/images/more_img.png"
        alt=""
      />
      <img v-else src="../assets/images/more_img_en.jpg" alt="" />
    </div>
    <div class="footer_box">
      <div class="footer_body">
        <div class="left_box">
          <div class="tips_box">
            <div class="logo">
              <img src="../assets/images/logo1.png" alt="" />
            </div>
            <div class="ewm_box">
              <div class="img">
                <img src="../assets/images/sph_ewm.jpg" alt="" />
                <div class="text">{{ $t("footer.video") }}</div>
              </div>
              <div class="img">
                <img src="../assets/images/gzh_ewm.jpg" alt="" />
                <div class="text">{{ $t("footer.wechat") }}</div>
              </div>
              <div class="address_box">
                <!-- <div class="phone">400-995-9192</div> -->
                <div class="phone">{{ $t("footer.phone") }}</div>
                <div class="address">{{ $t("footer.address") }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="right_box">
          <div class="menu_list">
            <div
              class="menu1"
              v-for="(item, index) in footerMenus"
              :key="index"
            >
              <div class="h1" @click="changeMenu(item, index)">
                {{ $t(item.name) }}
              </div>
              <div
                class="h2"
                v-for="(item1, index1) in item.tips"
                :key="index1"
              >
                {{ $t(item1) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menuIndex: "home",
      currentLang: localStorage.getItem("lang") || "zh",
      menus: [
        {
          name: "nav.home",
          path: "/Home",
          value: "home",
          tips: [
            "footer.aboutUs",
            "footer.businessScope",
            "footer.newsActivity",
          ],
        },
        {
          name: "nav.about",
          path: "/About",
          value: "about",
          tips: [
            "about.founderMessage",
            "about.companyIntro",
            "about.companyCulture",
          ],
        },
        {
          name: "nav.business",
          path: "/Business",
          value: "business",
          tips: ["footer.communityHealth", "footer.medicalTech"],
        },
        {
          name: "nav.news",
          path: "/News",
          value: "news",
          tips: ["footer.latestNews", "footer.realTimeActivity"],
        },
        {
          name: "nav.contact",
          path: "/Contact",
          value: "contact",
          tips: [
            "footer.recruitment",
            "footer.cooperation",
            "footer.complaints",
          ],
        },
      ],
    };
  },
  computed: {
    footerMenus() {
      return this.menus.filter((item) => !item.hiddenInFooter);
    },
  },
  watch: {
    $route(to) {
      let index = to.name;
      if (to.name === "news" && to.query.type == 2) {
        index = "culture";
      }
      sessionStorage.setItem("menuIndex", index);
      this.menuIndex = index;
      window.scrollTo(0, 0);
    },
  },
  mounted() {
    this.$nextTick(() => {
      let index = this.$route.name;
      if (this.$route.name === "news" && this.$route.query.type == 2) {
        index = "culture";
      }
      this.menuIndex = index;
      sessionStorage.setItem("menuIndex", index);
    });
  },
  methods: {
    //切换菜单
    changeMenu(item, index) {
      if (this.menuIndex === item.value) {
        return;
      }
      sessionStorage.setItem("menuIndex", item.value);
      this.menuIndex = item.value;
      this.$router.push(item.path);
    },
    // 切换语言
    switchLang(lang) {
      this.currentLang = lang;
      localStorage.setItem("lang", lang);
      this.$setLocale(lang);
    },
  },
};
</script>

<style lang="scss" scoped>
.main_box {
  width: 100%;
  height: 100%;
  min-width: 1400px;

  .header_box {
    width: 100%;
    height: 82px;
    position: sticky;
    top: 0;
    z-index: 999;
    box-shadow: 2px 5px 2px rgba(0, 0, 0, 0.1);
    border-bottom: 2px solid white;
    box-sizing: border-box;
    background-color: #e9fbfd;

    .logo_box {
      width: 1400px;
      height: 82px;
      margin: 0 auto;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .logo {
        width: 130px;
        height: auto;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        img {
          width: 100%;
          height: auto;
        }
      }

      .menu_box {
        width: auto;
        display: flex;
        justify-content: flex-end;
        align-items: center;

        .menu {
          width: auto;
          height: 52px;
          font-size: 18px;
          padding: 0 30px;
          box-sizing: border-box;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          cursor: pointer;

          &:hover {
            transition: all 0.3s;
            font-weight: bold;
          }
        }

        .menu_act {
          font-weight: bold;
        }

        // 语言切换样式
        .lang-switch {
          display: flex;
          align-items: center;
          margin-left: 20px;
          padding-left: 20px;
          border-left: 1px solid #ccc;
          font-size: 14px;
          color: #2c3e50;

          span {
            cursor: pointer;
            padding: 0 5px;

            &:not(:last-child):not(:first-child) {
              color: #999;
              cursor: default;
            }

            &.active {
              font-weight: bold;
              color: #49ced5;
            }

            &:hover:not(:last-child):not(:first-child) {
              color: #2c3e50;
            }
          }
        }
      }
    }
  }

  .content_box {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
  }

  .more_box {
    width: 100%;

    img {
      width: 100%;
    }
  }

  .footer_box {
    width: 100%;
    height: auto;
    background-color: #49ced5;

    .footer_body {
      width: 100%;
      max-width: 1400px;
      margin: 0 auto;
      padding: 50px 0;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: rgba(255, 255, 255, 1);

      .left_box {
        width: 40%;

        .tips_box {
          width: 100%;

          .logo {
            width: 120px;
            margin-bottom: 20px;
            height: auto;

            img {
              width: 100%;
              height: auto;
            }
          }

          .ewm_box {
            width: 100%;
            display: flex;
            justify-content: flex-start;
            align-items: flex-end;

            .img {
              width: 120px;
              margin-right: 10px;
              height: auto;

              img {
                width: 100%;
              }
            }

            .address_box {
              width: auto;
              text-align: start;

              .phone {
                width: 100%;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                margin-bottom: 10px;

                &:before {
                  content: "";
                  width: 24px;
                  height: 24px;
                  margin-right: 10px;
                  background-image: url("../assets/images/phone_icon.png");
                  background-size: 100% 100%;
                }
              }

              .address {
                width: 100%;
                display: flex;
                justify-content: flex-start;
                align-items: center;

                &:before {
                  content: "";
                  width: 24px;
                  height: 24px;
                  margin-right: 10px;
                  background-image: url("../assets/images/address_icon.png");
                  background-size: 100% 100%;
                }
              }
            }
          }
        }
      }

      .right_box {
        width: 50%;

        .menu_list {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: flex-start;

          .menu1 {
            width: auto;

            .h1 {
              font-size: 20px;
              font-weight: bold;
              margin-bottom: 20px;
              cursor: pointer;

              &:hover {
                text-decoration: underline;
              }
            }

            .h2 {
              margin-bottom: 10px;
            }
          }
        }
      }
    }
  }
}
</style>
